import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { notification } from 'antd';
import { BASE_URL } from '../../Config';

export const resumeFailedCampaigns = createAsyncThunk(
    'campaign/resumeFailedCampaigns',
    async (linkedinProfileId, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BASE_URL}/api/campaign/resume-failed-campaigns/${linkedinProfileId}`);
            response?.data?.message && notification.success({ message: 'Success', description: response?.data?.message });
            return response?.data;
        } catch (error) {
            notification.error({
                message: 'Error',
                description: error?.response?.data?.message || error?.response?.data?.errors?.[0]?.message || 'Failed to resume campaigns.',
            });
            return rejectWithValue(error?.response);
        }
    }
);

const resumeFailedCampaignsSlice = createSlice({
    name: 'resumeFailedCampaigns',
    initialState: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        data: null,
        error: null,
    },
    reducers: {
        resetResumeFailedCampaignsState: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.data = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(resumeFailedCampaigns.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.isError = false;
                state.data = null;
                state.error = null;
            })
            .addCase(resumeFailedCampaigns.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.data = action.payload;
                state.error = null;
            })
            .addCase(resumeFailedCampaigns.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.isError = true;
                state.data = null;
                state.error = action.payload;
            });
    },
});

export const { resetResumeFailedCampaignsState } = resumeFailedCampaignsSlice.actions;
export default resumeFailedCampaignsSlice.reducer;
